<template>
  <ul class="c-list--checkup">
    <li class="c-list--checkup__item">
      <span class="c-list--checkup__label judgement">判定</span>
      <div class="c-list--checkup__content">
        <p v-if="!hasError">
          nofollow属性が設定されているリンクタグは存在していませんでした。
        </p>
        <p v-else>
          nofollow属性が設定されているリンクタグが存在します。
        </p>
      </div>
    </li>
    <li v-if="noFollows.length" class="c-list--checkup__item">
      <span class="c-list--checkup__label detail">内容</span>
      <div class="c-list--checkup__content">
        <ul class="c-list--disc">
          <li v-for="(item, index) in noFollows" :key="index">
            {{ item }}
          </li>
        </ul>
      </div>
    </li>
    <li v-if="hasError" class="c-list--checkup__item">
      <span class="c-list--checkup__label hint">ヒント</span>
      <div class="c-list--checkup__content">
        <p>
          nofollow属性が設定されているリンクタグが存在します。<br />クローラーに、そのリンク先のページへの巡回を促さない、SEOとしての効果を渡さないという意図がある場合は問題ありませんが、意図せず設置している場合もありますので、一度、ご確認をお勧めします。
        </p>
        <dl>
          <dt>nofollow設置の例</dt>
          <dd>
            <ul class="c-list--disc">
              <li>
                サイト管理者が信頼できないコンテンツにリンクする場合
              </li>
              <li>販売されているといった有料リンクの場合</li>
              <li>
                サイト管理者が意図してクロール最適化の施策として重要なページの評価を上げたい場合
              </li>
            </ul>
          </dd>
        </dl>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    detail: {
      type: Object,
      required: true
    },
    hasError: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    noFollows() {
      if (this.detail.nofollow) {
        return this.detail.nofollow.filter(item => item);
      }
      return [];
    }
  }
};
</script>
